import React from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/seo/SEO";
import AboutSection from "@/components/ui/about-section";
import { useScrollTracking } from "@/hooks/useScrollTracking";
import { SocialShareWidget } from "@/components/SocialShareWidget";

export default function OverOns() {
  useScrollTracking();
  return (
    <>
      <SEO 
        title="Over SOL-VI - Zonnekracht voor een vitaal en onafhankelijk leven" 
        description="Ontdek het verhaal achter SOL-VI. Specialist in zonnepanelen, warmtepompen en thuisbatterijen in Elst, Gelderland. Door weer en wind, energie die met je meegaat." 
        type="website" 
      />
      <Header />
      
      <main className="min-h-screen">
        <AboutSection />
        
        <div className="container mx-auto px-4 py-8">
          <SocialShareWidget 
            title="Over SOL-VI - Zonnekracht voor een vitaal leven"
            description="Ontdek waarom SOL-VI uw partner is in duurzame energie. Door weer en wind, energie die met je meegaat."
            variant="follow"
            size="lg"
          />
        </div>
      </main>
      
      <Footer />
    </>
  );
}